module.exports = __webpack_public_path__ + "static/media/kv23.63c0b206.jpg";